module.exports = __webpack_public_path__ + "static/media/macbookair.4b3e4785.svg";